/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createSqlConnectorStatusFromDiscriminatorValue, serializeRegisterSqlConnectorRequest, serializeSqlConnectorStatus, type ErrorResponse, type InternalErrorResponse, type RegisterSqlConnectorRequest, type SqlConnectorStatus } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/sql-connector/register
 */
export interface RegisterRequestBuilder extends BaseRequestBuilder<RegisterRequestBuilder> {
    /**
     * Announces an on-premise connector — the agent that reads SAP Business One data and pushes it to this API — and returns the connectorId every other endpoint in this group is addressed by. Call it on connector startup. Registration is idempotent on connectorName plus hostName: registering again with the same pair updates the stored version, status and metadata and returns the original connectorId, so restarts and redeploys do not create duplicates. A different name or host is a different connector. The connector is bound to the organization the credentials resolve to; there is no organization field in the request.
     * @param body Identifies a connector to the API on startup. Name plus host is the identity: registering thesame pair again updates the existing connector rather than creating a second one.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SqlConnectorStatus>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: RegisterSqlConnectorRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SqlConnectorStatus | undefined>;
    /**
     * Announces an on-premise connector — the agent that reads SAP Business One data and pushes it to this API — and returns the connectorId every other endpoint in this group is addressed by. Call it on connector startup. Registration is idempotent on connectorName plus hostName: registering again with the same pair updates the stored version, status and metadata and returns the original connectorId, so restarts and redeploys do not create duplicates. A different name or host is a different connector. The connector is bound to the organization the credentials resolve to; there is no organization field in the request.
     * @param body Identifies a connector to the API on startup. Name plus host is the identity: registering thesame pair again updates the existing connector rather than creating a second one.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: RegisterSqlConnectorRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const RegisterRequestBuilderUriTemplate = "{+baseurl}/api/sql-connector/register";
/**
 * Metadata for all the requests in the request builder.
 */
export const RegisterRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: RegisterRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSqlConnectorStatusFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeRegisterSqlConnectorRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
